import { render, staticRenderFns } from "./RestrictedSoftware.vue?vue&type=template&id=3f77239b"
import script from "@/scripts/adminManager/systemManager/restrictedSoftware.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/systemManager/restrictedSoftware.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports